import { render } from "./UserSelector.vue?vue&type=template&id=68282f68"
import script from "./UserSelector.vue?vue&type=script&lang=ts"
export * from "./UserSelector.vue?vue&type=script&lang=ts"
script.render = render

export default script